import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { observer, inject } from "mobx-react";

import SvgsIcons from "@/components/svgs/icons";
import { Footer } from './css'

const Chunk = ({ store }) => {
  const { isMobile } = store.common;

  return (
    <Footer className={isMobile ? 'mobile center' : 'center'}>
      <div className="links">
        <strong>Community</strong>
        <a href="https://twitter.com/dmailofficial" className="twitter" target="_blank"><SvgsIcons type="twitter" fill="#666" width="15" height="14" /></a>
        <a href="https://t.me/dmailofficial" className="telegram" target="_blank"><SvgsIcons type="telegram" fill="#666" width="20" height="20" /></a>
        <a href="https://medium.com/@dmail_official" className="m" target="_blank"><SvgsIcons type="m" fill="#666" width="20" height="20" /></a>
        <a href="https://discord.gg/QbvaeqwMFg" className="discord" target="_blank"><SvgsIcons type="discord" fill="#666" width="20" height="16" /></a>
      </div>
      <div className="ltd">@Dmail Network Foundation LTD.</div>
    </Footer>
  )
}

export default inject("store")(observer(Chunk))